import { ImusicianIcon } from '@imus/base-ui';

export default ImusicianIcon;
